/*!

=========================================================
* Black Dashboard PRO React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// react plugin used to create charts
import { Line, Bar } from "react-chartjs-2";
import { ChartArea } from 'chart.js'
// react plugin for creating vector maps
import { VectorMap } from "react-jvectormap";

import { Redirect } from "react-router-dom";

// reactstrap components
import {
  Button,
  Collapse,
  Card,
  CardImg,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  CardGroup,
  CardText,
  Nav,
  NavItem,
  NavLink,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Label,
  FormGroup,
  Input,
  Progress,
  Table,
  Row,
  Col,
  Spinner
} from "reactstrap";

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchGetDataModel, fetchGetStatsModel, fetchGetTrendModel, fetchGetPingModel } from "../actions/model_actions";
import { isObjEmpty } from "../utils/utils";

// core components
import {
  chartExample1,
  chartExample2,
  chartExample3,
  chartExample4,
  chartExample5,
  chartExample6,
  chartExample11
} from "variables/charts.js";

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bigChartData: "data1",
      openedCollapses: [],
      showModels: false,
      modelData: {},
      modelStats: {},
      modelTrend: {},
      status: null
    };
  }

  componentDidMount() {
    // console.log("Entra")
    const {fetchGetDataModel, fetchGetStatsModel, fetchGetTrendModel, fetchGetPingModel, location, user} = this.props;
    // console.log(location.state.user.user_logged.user_id);
    // let user_id = localStorage.getItem();
    let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    // this.setState({showModelInfo: true, modelInfo: info, model_id: info.model_id});
    fetchGetDataModel(idToken, location.state.model_id);
    fetchGetStatsModel(idToken, location.state.model_id);
    fetchGetTrendModel(idToken, location.state.model_id);
    fetchGetPingModel(idToken, location.state.user.user_logged.user_id, location.state.model_id);
  }

  componentDidUpdate(prevProps, prevState){
    const { auth, fetchGetDataModel, fetchGetStatsModel, fetchGetTrendModel, location, model } = this.props;
    if(
        auth 
        && auth.token 
        && auth.token.action 
        && auth.token.action === "New Token" 
        && auth.token.idToken 
        && prevProps.auth.token 
        && location
        && location.state
        && auth.token.idToken !== prevProps.auth.token.idToken
    ) {
      console.log("Case 1: ", auth, prevProps.auth)
      let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      fetchGetDataModel(idToken, location.state);
      fetchGetStatsModel(idToken, location.state);
      fetchGetTrendModel(idToken, location.state);
    }
    if(prevProps.auth.token === null && auth.token !== prevProps.auth.token) {
      console.log("Case 2: ", auth, prevProps.auth)
      let idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      fetchGetDataModel(idToken, location.state);
      fetchGetStatsModel(idToken, location.state);
      fetchGetTrendModel(idToken, location.state);
    }
    if(!prevProps.model.model_data && model.model_data || (prevProps.model.model_data && model.model_data && (prevProps.model.model_data !== model.model_data))) {
      // console.log('Props: ', model.model_data, 'PrevProps: ', prevProps.model.model_data)
      this.setState({modelData: this.props.model.model_data});
    }
    if(!prevProps.model.model_stats && model.model_stats || (prevProps.model.model_stats && model.model_stats && (prevProps.model.model_stats !== model.model_stats))) {
      // console.log('Props: ', model.model_data, 'PrevProps: ', prevProps.model.model_data)
      this.setState({modelStats: this.props.model.model_stats});
    }
    if(!prevProps.model.model_trend && model.model_trend || (prevProps.model.model_trend && model.model_trend && (prevProps.model.model_trend !== model.model_trend))) {
      // console.log('Props: ', model.model_data, 'PrevProps: ', prevProps.model.model_data)
      this.setState({modelTrend: this.props.model.model_trend});
    }
    if((model && model.ping && prevProps.model && !prevProps.model.ping) || 
      (model && model.ping && prevProps.model && prevProps.model.ping && model.ping !== prevProps.model.ping)) {
      // console.log(model, prevProps.model)
      this.setState({status: model.ping.status})
    }
  }

  setBgChartData = name => {
    this.setState({
      bigChartData: name
    });
  };

  collapsesToggle = (e, collapse) => {
    e.preventDefault();
    let openedCollapses = this.state.openedCollapses;
    if (openedCollapses.includes(collapse)) {
      this.setState({
        openedCollapses: openedCollapses.filter(item => item !== collapse)
      });
    } else {
      openedCollapses.push(collapse);
      this.setState({
        openedCollapses: openedCollapses
      });
    }
  };

  backToModels = () => {
    // console.log(info)
    this.setState({showModels: true, modelData: {}});
  }

  getPing(model_id) {
    const { fetchGetPingModel } = this.props;
    console.log(model_id)
    const idToken = document.cookie.replace(/(?:(?:^|.*;\s*)idToken\s*\=\s*([^;]*).*$)|^.*$/, "$1");
      // model.user_models.map();
      let objRes = {
        token: idToken,
        userId: "diego-kin",
        model_id: model_id
      }
      fetchGetPingModel(objRes);
  };

  render() {
    const { showModels, modelData, modelStats, modelTrend, status } = this.state;
    const { model } = this.props;

    if(showModels) {
      return <Redirect from="/user/dashboard" to="/user/models" />
    }
    // console.log("Model Trend: ", modelTrend.success_calls ? modelTrend.success_calls.date.map(val => {
    //   return (new Date(val)).getDate()
    // } ) : null)
    
    let data;
    if(model && model.model_trend){
      data = canvas => {
        canvas.parentNode.style.minHeight = '383px'
        let ctx = canvas.getContext("2d");
        var gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, "rgba(0,135,191,0.2)");
        gradientStroke.addColorStop(0.8, "rgba(0,135,191,0.1)");
        gradientStroke.addColorStop(0, "rgba(0,84,119,0.1)"); //blue colors
        return {
          // labels: ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],
          labels: modelTrend && !isObjEmpty(modelTrend) && modelTrend.success_calls && modelTrend.success_calls.count ? modelTrend.success_calls.date.map(val => (new Date(val)).toISOString()) : [],
          // labels: ["2020-01-01T05:00:00.000Z", "2020-01-02T05:00:00.000Z", "2020-01-03T05:00:00.000Z", "2020-01-04T05:00:00.000Z", "2020-01-05T05:00:00.000Z", "2020-01-06T05:00:00.000Z", "2020-01-07T05:00:00.000Z", "2020-01-08T05:00:00.000Z"],
          datasets: [
            {
              label: "Success",
              lineTension: 0.1,
              fill: true,
              backgroundColor: gradientStroke,
              borderColor: "#1f8ef1",
              borderWidth: 2,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "#1f8ef1",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              //pointHoverBorderColor:'rgba(35,46,55,1)',
              pointBorderWidth: 5,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 15,
              pointRadius: 2,
              cubicInterpolationMode: 'monotone',
              data: modelTrend && !isObjEmpty(modelTrend) && modelTrend.success_calls && modelTrend.success_calls.count ? modelTrend.success_calls.count : []
            },
            {
              label: "Error",
              fill: true,
              lineTension: 0.1,
              backgroundColor: "rgba(222,45,45,0.1)",
              borderColor: "rgba(222,45,45,1)",
              borderWidth: 1,
              borderDash: [],
              borderDashOffset: 0.0,
              pointBackgroundColor: "rgba(222,45,45,1)",
              pointBorderColor: "rgba(255,255,255,0)",
              pointHoverBackgroundColor: "#be55ed",
              //pointHoverBorderColor:'rgba(35,46,55,1)',
              pointBorderWidth: 5,
              pointHoverRadius: 1,
              pointHoverBorderWidth: 5,
              pointRadius: 2,
              cubicInterpolationMode: 'monotone',
              data: modelTrend && !isObjEmpty(modelTrend) && modelTrend.error_calls && modelTrend.error_calls.count ? modelTrend.error_calls.count : []
            },
          ]
        };
      }
      chartExample6.data = data;
    }

    let date_added = modelData && !isObjEmpty(modelData) && modelData.created_at ? new Date(modelData.created_at) : "";

    
    return (
      <>
        <div className="content">
          <Row>
            <Col lg="12">
              <Card className="card-plain" >
                <CardHeader>
                  <Row>
                    <Col md="6">
                      <CardTitle tag="h2" style={{marginRight: "10px", display: "inline-block"}}>
                        <div>
                          {modelData && !isObjEmpty(modelData) ? modelData.model_name + " (" + modelData.model_id + ")" : " "}
                        </div>
                      </CardTitle>
                      {status === 200 ? 
                        <div style={{display: "inline-block"}}>
                          <div style={{borderRadius: "50%", background: "#28a745", width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <i className="tim-icons icon-check-2" style={{fontSize: "15px"}}/>
                          </div>
                        </div> : 
                        status === null ? 
                        <div style={{display: "inline-block"}}>
                          <div style={{borderRadius: "50%", background: "#ffc107", width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                            <i className="tim-icons icon-watch-time" style={{fontSize: "15px"}}/>
                          </div>
                        </div> : 
                        <div style={{display: "inline-block"}}>
                          <div style={{borderRadius: "50%", background: "#dc3545", width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center"}}>
                          <i className="tim-icons icon-simple-remove" style={{fontSize: "15px"}}/>
                          </div>
                        </div>} 
                    </Col>
                    {/* <Col className="ml-auto" md="3"> */}
                    <Nav navbar className="ml-auto" style={{cursor: "pointer"}}>
                      <NavItem onClick={this.backToModels}>
                        <NavLink
                          to="/user/models"
                          className="nav-link text-info"
                        >
                          <i className="tim-icons icon-minimal-left" /> Back to Models
                        </NavLink>
                      </NavItem>
                    </Nav>
                    {/* </Col> */}
                  </Row>
                </CardHeader>
                <CardBody >
                  <Row>
                    <Col lg="5">
                      <Row style={{marginLeft: '-30px', marginRight: '-30px'}}>
                        <Col md="4" >
                          <Card className="card-stats">
                            <CardBody>
                              <Row>
                                <Col xs="5">
                                  <div className="info-icon-2 text-center icon-success">
                                    <i className="tim-icons icon-chart-bar-32" />
                                  </div>
                                </Col>
                                <Col xs="7">
                                  <div className="numbers">
                                    {/* {console.log(model && model.model_stats ? model.model_stats.total_calls : "")} */}
                                    <CardTitle tag="h3">{modelStats && !isObjEmpty(modelStats) ? modelStats.total_calls : <Spinner color="light" size="md"/>}</CardTitle>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                            <CardFooter>
                              <hr />
                              <div className="stats">
                                Total Calls
                              </div>
                            </CardFooter>
                          </Card>
                        </Col>
                        <Col md="4" >
                          <Card className="card-stats">
                            <CardBody>
                              <Row>
                                <Col xs="5">
                                  <div className="info-icon-2 text-center icon-info">
                                    <i className="tim-icons icon-calendar-60" />
                                  </div>
                                </Col>
                                <Col xs="7">
                                  <div className="numbers">
                                    <CardTitle tag="h3">{modelStats && !isObjEmpty(modelStats) ? modelStats.success_calls_last_month : <Spinner color="light" size="md"/>}</CardTitle>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                            <CardFooter>
                              <hr />
                              <div className="stats">
                                Calls Last Month
                              </div>
                            </CardFooter>
                          </Card>
                        </Col>
                        <Col md="4" >
                          <Card className="card-stats">
                            <CardBody>
                              <Row>
                                <Col xs="5">                                      
                                  <div className="info-icon-2 text-center icon-danger">
                                    <i className="tim-icons icon-simple-remove" />
                                  </div>
                                </Col>
                                <Col xs="7">
                                  <div className="numbers">
                                    <CardTitle tag="h3">{modelStats && !isObjEmpty(modelStats) ? modelStats.total_error_calls : <Spinner color="light" size="md"/>}</CardTitle>
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                            <CardFooter>
                              <hr />
                              <div className="stats">
                                Error Calls
                              </div>
                            </CardFooter>
                          </Card>
                        </Col>
                      </Row>
                      <Row>
                        <Card style={{position: "relative"}}>
                          {modelData && !isObjEmpty(modelData) ?
                            <CardBody>
                              <Col md ="12">
                                {/* <CardTitle tag="h4">Group Box A</CardTitle> */}
                                <CardText tag="h4" >{modelData && !isObjEmpty(modelData) ? modelData.description : ""}</CardText>
                                <br/>
                                {/* {console.log(location.state.created_at)} */}
                                <CardText tag="h6">Created At</CardText>
                                <CardText >{date_added !== "" ? date_added.toISOString().split('T')[0] : ""}</CardText>
                                {/* <CardText >last_updated</CardText> */}
                                <br></br>
                                {/* <CardText tag="h5">Performance metrics?</CardText> */}
                                <div
                                  aria-multiselectable={true}
                                  className="card-collapse"
                                  id="accordion"
                                  role="tablist"
                                  style={{border: "1px solid #525f7f", padding: "0.01em 10px", borderRadius: "5px"}}
                                >
                                  {modelData && !isObjEmpty(modelData) && modelData.versioning && modelData.versioning.map((val, index) => 
                                    <Card className="card-plain" key={index}>
                                      <CardHeader role="tab">
                                        <a
                                          aria-expanded={this.state.openedCollapses.includes(
                                            index
                                          )}
                                          href="#pablo"
                                          data-parent="#accordion"
                                          data-toggle="collapse"
                                          onClick={e => this.collapsesToggle(e, index)}
                                        >
                                          {val.version_name}{" "}
                                          <i className="tim-icons icon-minimal-down" />
                                        </a>
                                      </CardHeader>
                                      {/* {console.log(this.state.openedCollapses, index)} */}
                                      <Collapse
                                        role="tabpanel"
                                        isOpen={this.state.openedCollapses.includes(
                                          index
                                        )}
                                      >
                                        <CardBody >
                                          <p>
                                            <span style={{fontWeight: 700, marginRight: "5px"}}>Version Date: </span>{val.version_date}
                                          </p>
                                          <p>
                                            <span style={{fontWeight: 700, marginRight: "5px"}}>Version Performance Metrics: </span>
                                          </p>
                                          {Object.keys(val.version_performance_metrics).length !== 0 ? Object.keys(val.version_performance_metrics).map((aux, j) => {
                                            return (
                                              <div key={j}>
                                                <span style={{fontWeight: 600, marginRight: "5px"}}>{aux + ": "}</span>{val.version_performance_metrics[aux]}
                                              </div>
                                            );
                                            }) : 
                                            <CardText tag="h6" style={{display: "flex", justifyContent: "center", alignItems: "center"}}>This model doesn't have any metrics</CardText>
                                          }
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  )}
                                </div>
                                {/* <br></br> */}
                              </Col> 
                            </CardBody> : 
                            <Spinner color="light" style={{ position: "absolute", width: '4rem', height: '4rem', top: "125px", left:"45%" }}/>
                          }
                        </Card>
                      </Row>
                    </Col>
                    <Col lg="7" >
                      <Card className="card-chart" style={{minHeight: '410px', maxHeight: '410px'}}>
                        <CardBody style={{position: "relative"}}>
                          {modelTrend && !isObjEmpty(modelTrend) ?
                            <div className='chart-area-model' >
                              <Line
                                data={chartExample6.data}
                                height={380}
                                options={chartExample6.options}
                              />
                            </div> : 
                            <Spinner color="light" style={{ position: "absolute", width: '4rem', height: '4rem', top: "170px", left:"45%" }}/>
                          }
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </>
    );
  }
}

function mapStateToProps({model, auth, user}){
  return{
      model,
      auth,
      user
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators(
      { fetchGetDataModel, fetchGetStatsModel, fetchGetTrendModel, fetchGetPingModel }, dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
/* <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-success">
                        <i className="tim-icons icon-single-02" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Users</p>
                        <CardTitle tag="h3">150,000</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-trophy" /> Customers feedback
                  </div>
                </CardFooter>
              </Card>
            </Col>
            <Col lg="3" md="6">
              <Card className="card-stats">
                <CardBody>
                  <Row>
                    <Col xs="5">
                      <div className="info-icon text-center icon-danger">
                        <i className="tim-icons icon-molecule-40" />
                      </div>
                    </Col>
                    <Col xs="7">
                      <div className="numbers">
                        <p className="card-category">Errors</p>
                        <CardTitle tag="h3">12</CardTitle>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <hr />
                  <div className="stats">
                    <i className="tim-icons icon-watch-time" /> In the last
                    hours
                  </div>
                </CardFooter>
              </Card>
            </Col> */
            /* <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Total Shipments</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-bell-55 text-primary" />{" "}
                    763,215
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={chartExample2.data}
                      options={chartExample2.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Daily Sales</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-delivery-fast text-info" />{" "}
                    3,500€
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Bar
                      data={chartExample3.data}
                      options={chartExample3.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="4">
              <Card className="card-chart">
                <CardHeader>
                  <h5 className="card-category">Completed Tasks</h5>
                  <CardTitle tag="h3">
                    <i className="tim-icons icon-send text-success" /> 12,100K
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <div className="chart-area">
                    <Line
                      data={chartExample4.data}
                      options={chartExample4.options}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col> */
/* <Row>
            <Col lg="5">
              <Card className="card-tasks">
                <CardHeader>
                  <h6 className="title d-inline">Tasks(5)</h6>
                  <p className="card-category d-inline">today</p>
                  <UncontrolledDropdown>
                    <DropdownToggle
                      caret
                      className="btn-icon"
                      color="link"
                      data-toggle="dropdown"
                      type="button"
                    >
                      <i className="tim-icons icon-settings-gear-63" />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        Action
                      </DropdownItem>
                      <DropdownItem
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        Another action
                      </DropdownItem>
                      <DropdownItem
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                      >
                        Something else
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </CardHeader>
                <CardBody>
                  <div className="table-full-width table-responsive">
                    <Table>
                      <tbody>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">Update the Documentation</p>
                            <p className="text-muted">
                              Dwuamish Head, Seattle, WA 8:47 AM
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip786630859"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip786630859"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input
                                  defaultChecked
                                  defaultValue=""
                                  type="checkbox"
                                />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">GDPR Compliance</p>
                            <p className="text-muted">
                              The GDPR is a regulation that requires businesses
                              to protect the personal data and privacy of Europe
                              citizens for transactions that occur within EU
                              member states.
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip155151810"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip155151810"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">Solve the issues</p>
                            <p className="text-muted">
                              Fifty percent of all respondents said they would
                              be more likely to shop at a company
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip199559448"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip199559448"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">Release v2.0.0</p>
                            <p className="text-muted">
                              Ra Ave SW, Seattle, WA 98116, SUA 11:19 AM
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip989676508"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip989676508"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">Export the processed files</p>
                            <p className="text-muted">
                              The report also shows that consumers will not
                              easily forgive a company once a breach exposing
                              their personal data occurs.
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip557118868"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip557118868"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <FormGroup check>
                              <Label check>
                                <Input defaultValue="" type="checkbox" />
                                <span className="form-check-sign">
                                  <span className="check" />
                                </span>
                              </Label>
                            </FormGroup>
                          </td>
                          <td>
                            <p className="title">Arival at export process</p>
                            <p className="text-muted">
                              Capitol Hill, Seattle, WA 12:34 AM
                            </p>
                          </td>
                          <td className="td-actions text-right">
                            <Button
                              color="link"
                              id="tooltip143185858"
                              title=""
                              type="button"
                            >
                              <i className="tim-icons icon-pencil" />
                            </Button>
                            <UncontrolledTooltip
                              delay={0}
                              target="tooltip143185858"
                            >
                              Edit Task
                            </UncontrolledTooltip>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col lg="7">
              <Card>
                <CardHeader>
                  <div className="tools float-right">
                    <UncontrolledDropdown>
                      <DropdownToggle
                        caret
                        className="btn-icon"
                        color="link"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i className="tim-icons icon-settings-gear-63" />
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Action
                        </DropdownItem>
                        <DropdownItem
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Another action
                        </DropdownItem>
                        <DropdownItem
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Something else
                        </DropdownItem>
                        <DropdownItem
                          className="text-danger"
                          href="#pablo"
                          onClick={e => e.preventDefault()}
                        >
                          Remove Data
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                  <CardTitle tag="h5">Management Table</CardTitle>
                </CardHeader>
                <CardBody>
                  <Table responsive>
                    <thead className="text-primary">
                      <tr>
                        <th className="text-center">#</th>
                        <th>Name</th>
                        <th>Job Position</th>
                        <th>Milestone</th>
                        <th className="text-right">Salary</th>
                        <th className="text-right">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/tania.jpg")}
                            />
                          </div>
                        </td>
                        <td>Tania Mike</td>
                        <td>Develop</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">25%</span>
                              <Progress bar max="100" value="25" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 99,225</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="success"
                            id="tooltip618296632"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip618296632"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="danger"
                            id="tooltip707467505"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip707467505"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/robi.jpg")}
                            />
                          </div>
                        </td>
                        <td>John Doe</td>
                        <td>CEO</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">77%</span>
                              <Progress bar max="100" value="77" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 89,241</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="success"
                            id="tooltip216846074"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip216846074"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="danger"
                            id="tooltip391990405"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip391990405"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/lora.jpg")}
                            />
                          </div>
                        </td>
                        <td>Alexa Mike</td>
                        <td>Design</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">41%</span>
                              <Progress bar max="100" value="41" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 92,144</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="success"
                            id="tooltip191500186"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip191500186"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon btn-neutral"
                            color="danger"
                            id="tooltip320351170"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip320351170"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/jana.jpg")}
                            />
                          </div>
                        </td>
                        <td>Jana Monday</td>
                        <td>Marketing</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">50%</span>
                              <Progress bar max="100" value="50" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 49,990</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon"
                            color="success"
                            id="tooltip345411997"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip345411997"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon"
                            color="danger"
                            id="tooltip601343171"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip601343171"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/mike.jpg")}
                            />
                          </div>
                        </td>
                        <td>Paul Dickens</td>
                        <td>Develop</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">100%</span>
                              <Progress bar max="100" value="100" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 69,201</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon"
                            color="success"
                            id="tooltip774891382"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip774891382"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon"
                            color="danger"
                            id="tooltip949929353"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip949929353"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-center">
                          <div className="photo">
                            <img
                              alt="..."
                              src={require("assets/img/emilyz.jpg")}
                            />
                          </div>
                        </td>
                        <td>Manuela Rico</td>
                        <td>Manager</td>
                        <td className="text-center">
                          <div className="progress-container progress-sm">
                            <Progress multi>
                              <span className="progress-value">15%</span>
                              <Progress bar max="100" value="15" />
                            </Progress>
                          </div>
                        </td>
                        <td className="text-right">€ 99,201</td>
                        <td className="text-right">
                          <Button
                            className="btn-link btn-icon"
                            color="success"
                            id="tooltip30547133"
                            size="sm"
                            title="Refresh"
                            type="button"
                          >
                            <i className="tim-icons icon-refresh-01" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip30547133"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                          <Button
                            className="btn-link btn-icon"
                            color="danger"
                            id="tooltip156899243"
                            size="sm"
                            title="Delete"
                            type="button"
                          >
                            <i className="tim-icons icon-simple-remove" />
                          </Button>
                          <UncontrolledTooltip
                            delay={0}
                            target="tooltip156899243"
                          >
                            Tooltip on top
                          </UncontrolledTooltip>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </Col>
            <Col lg="12">
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">Global Sales by Top Locations</CardTitle>
                  <p className="card-category">
                    All products that were shipped
                  </p>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col md="6">
                      <Table responsive>
                        <tbody>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/US.png")}
                                />
                              </div>
                            </td>
                            <td>USA</td>
                            <td className="text-right">2.920</td>
                            <td className="text-right">53.23%</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/DE.png")}
                                />
                              </div>
                            </td>
                            <td>Germany</td>
                            <td className="text-right">1.300</td>
                            <td className="text-right">20.43%</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/AU.png")}
                                />
                              </div>
                            </td>
                            <td>Australia</td>
                            <td className="text-right">760</td>
                            <td className="text-right">10.35%</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/GB.png")}
                                />
                              </div>
                            </td>
                            <td>United Kingdom</td>
                            <td className="text-right">690</td>
                            <td className="text-right">7.87%</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/RO.png")}
                                />
                              </div>
                            </td>
                            <td>Romania</td>
                            <td className="text-right">600</td>
                            <td className="text-right">5.94%</td>
                          </tr>
                          <tr>
                            <td>
                              <div className="flag">
                                <img
                                  alt="..."
                                  src={require("assets/img/BR.png")}
                                />
                              </div>
                            </td>
                            <td>Brasil</td>
                            <td className="text-right">550</td>
                            <td className="text-right">4.34%</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                    <Col className="ml-auto mr-auto" md="6">
                      <VectorMap
                        map={"world_mill"}
                        backgroundColor="transparent"
                        zoomOnScroll={false}
                        containerStyle={{
                          width: "100%",
                          height: "300px"
                        }}
                        regionStyle={{
                          initial: {
                            fill: "#e4e4e4",
                            "fill-opacity": 0.9,
                            stroke: "none",
                            "stroke-width": 0,
                            "stroke-opacity": 0
                          }
                        }}
                        series={{
                          regions: [
                            {
                              values: mapData,
                              scale: ["#AAAAAA", "#444444"],
                              normalizeFunction: "polynomial"
                            }
                          ]
                        }}
                      />
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row> */
/* <CardGroup>
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Total Calls.</CardTitle>
                                <CardText style={{color: "#fff"}}>2.3K</CardText>
                              </CardBody>
                            </Card >
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Calls Last Month</CardTitle>
                                <CardText style={{color: "#fff"}}>500</CardText>
                              </CardBody>
                            </Card>
                            <Card style={{border: "1px solid", backgroundColor: '#2083f7'}} className="text-center">
                              <CardBody>
                                <CardTitle tag="h4" style={{color: "#fff"}}>Error Calls</CardTitle>                              
                                <CardText style={{color: "#fff"}}>2.3K</CardText>
                              </CardBody>
                            </Card>
                          </CardGroup> */

                          /* <Col sm="6">
                      <ButtonGroup
                        className="btn-group-toggle float-right"
                        data-toggle="buttons"
                      >
                        <Button
                          color="info"
                          id="0"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data1"
                          })}
                          onClick={() => this.setBgChartData("data1")}
                        >
                          <input defaultChecked name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Accounts
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-single-02" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="1"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data2"
                          })}
                          onClick={() => this.setBgChartData("data2")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Purchases
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-gift-2" />
                          </span>
                        </Button>
                        <Button
                          color="info"
                          id="2"
                          size="sm"
                          tag="label"
                          className={classNames("btn-simple", {
                            active: this.state.bigChartData === "data3"
                          })}
                          onClick={() => this.setBgChartData("data3")}
                        >
                          <input name="options" type="radio" />
                          <span className="d-none d-sm-block d-md-block d-lg-block d-xl-block">
                            Sessions
                          </span>
                          <span className="d-block d-sm-none">
                            <i className="tim-icons icon-tap-02" />
                          </span>
                        </Button>
                      </ButtonGroup>
                    </Col> */